import { EServiceType } from '../internalTypes';

interface IGetServiceIdParams {
  services: EServiceType[];
}

export function getServiceId(terms: IGetServiceIdParams): string {
  const { services } = terms;

  return services.join('+');
}
